// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/**\n* Colors\n*/\n.DotClassifications_header__7K8BT {\n  margin-bottom: 28px; }\n\n.DotClassifications_wrapper__3Gxkd {\n  position: relative; }\n\n.DotClassifications_tempButtons__2Fso0 {\n  display: flex;\n  position: absolute;\n  top: 0;\n  right: 0; }\n  .DotClassifications_tempButtons__2Fso0 > *:not(:last-child) {\n    margin-right: 8px; }\n\n.DotClassifications_modalWrapper__3q2Xw .ant-modal-header {\n  display: none !important; }\n\n.DotClassifications_modalWrapper__3q2Xw .ant-modal-body > div {\n  border-top: 0 !important; }\n", ""]);
// Exports
exports.locals = {
	"header": "DotClassifications_header__7K8BT",
	"wrapper": "DotClassifications_wrapper__3Gxkd",
	"tempButtons": "DotClassifications_tempButtons__2Fso0",
	"modalWrapper": "DotClassifications_modalWrapper__3q2Xw"
};
module.exports = exports;
